import axios from "axios";
import { Base_URL } from "../url";

export const saveAmountDisbursement = async (disbursementData) => {
  try {
    const response = await axios.post(`${Base_URL}/Disbursement/AmountDisbursement`, disbursementData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save disbursement details";
  }
};